<template>
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="
                M9.5625 1.0625V9.13086L11.9863 6.67383C12.2077 6.47461 12.4622 6.375
                12.75 6.375C13.0378 6.375 13.2923 6.47461 13.5137 6.67383C13.7129
                6.89518 13.8125 7.14974 13.8125 7.4375C13.8125 7.72526 13.7129 7.97982
                13.5137 8.20117L9.26367 12.4512C9.04232 12.6504 8.78776 12.75 8.5
                12.75C8.21224 12.75 7.95768 12.6504 7.73633 12.4512L3.48633
                8.20117C3.28711 7.97982 3.1875 7.72526 3.1875 7.4375C3.1875 7.14974
                3.28711 6.89518 3.48633 6.67383C3.70768 6.47461 3.96224 6.375 4.25
                6.375C4.53776 6.375 4.79232 6.47461 5.01367 6.67383L7.4375 9.13086V1.0625
                C7.4375 0.752604 7.53711 0.498047 7.73633 0.298828C7.93555 0.0996094
                8.1901 0 8.5 0C8.8099 0 9.06445 0.0996094 9.26367 0.298828C9.46289
                0.498047 9.5625 0.752604 9.5625 1.0625ZM2.125 11.6875H5.51172L7.00586
                13.1816C7.42643 13.6022 7.92448 13.8125 8.5 13.8125C9.05339 13.8125
                9.55143 13.6022 9.99414 13.1816L11.5215 11.6875H14.875C15.4727 11.7096
                15.9707 11.9199 16.3691 12.3184C16.7676 12.7168 16.9779 13.2148 17
                13.8125V14.875C16.9779 15.4727 16.7676 15.9707 16.3691 16.3691C15.9707
                16.7676 15.4727 16.9779 14.875 17H2.125C1.52734 16.9779 1.0293 16.7676
                0.630859 16.3691C0.232422 15.9707 0.0221354 15.4727 0 14.875V13.8125C0.0221354
                13.2148 0.232422 12.7168 0.630859 12.3184C1.0293 11.9199 1.52734 11.7096
                2.125 11.6875ZM14.3438 13.5469C13.8568 13.5911 13.5911 13.8568 13.5469
                14.3438C13.5911 14.8307 13.8568 15.0964 14.3438 15.1406C14.8307 15.0964
                15.0964 14.8307 15.1406 14.3438C15.0964 13.8568 14.8307 13.5911 14.3438
                13.5469Z
            "
            fill="currentColor"
        />
    </svg>
</template>